/* THE HOLD MENU'S PLACEMENT (his 10-15 word, with an Instagram still: "if we hold a message it shows this so message moves a bit
 * up and shows the emojis on top and other options on the bottom while blurring the others"). Pure, so a test can EXECUTE it:
 * the held bubble stays where it was (lifted a few px), the emoji bar sits above it on the bubble's own side, the actions card
 * below it on the same side — and when the stack would leave the window (a message near the bottom or the top), the WHOLE
 * stack moves, never one piece, so the bubble the coach held stays between its emojis and its actions. */

export type Box = { top: number; left: number; width: number; height: number };
export type HoldPlace = { bar: { top: number; left: number } | null; bubble: { top: number; left: number }; bubbleHeight: number;
  card: { top: number; left: number } };

/** The gap between the three pieces, the lift of the held bubble, the margin kept from the window's edges (CSS px). */
export const HOLD_GAP = 8;
export const HOLD_LIFT = 6;
export const HOLD_EDGE = 12;
/** The least of a bubble kept when it must be cut (a line and a half of words). */
export const HOLD_MIN_BUBBLE = 44;

/* RE-AIMED 2026-10-16 (his word: "make sure if it's a message close to the edges of the screen that … all the containers are
 * not going over the edge"): the bubble is held inside the sides too, and a bubble taller than the room left by the six and
 * the card is CUT to fit (`bubbleHeight`; the menu clips the copy) — nothing is drawn past an edge. The phone's
 * `HoldPlacement.swift` is the twin (it also subtracts the screen's safe area). */
export function holdPlacement(bubble: Box, bar: { width: number; height: number } | null, card: { width: number; height: number },
                              mine: boolean, view: { width: number; height: number }): HoldPlace {
  const barH = bar === null ? 0 : bar.height + HOLD_GAP;
  const minY = HOLD_EDGE;
  const maxY = view.height - HOLD_EDGE;
  const bubbleHeight = Math.min(bubble.height, Math.max(HOLD_MIN_BUBBLE, maxY - minY - barH - HOLD_GAP - card.height));
  const total = barH + bubbleHeight + HOLD_GAP + card.height;
  const wanted = bubble.top - HOLD_LIFT - barH;
  // Fits → where it was, lifted; too low → up until the card's foot meets the edge; too high → down to the top edge.
  const top = Math.max(minY, Math.min(wanted, maxY - total));
  const inside = (left: number, width: number) => Math.max(HOLD_EDGE, Math.min(left, view.width - HOLD_EDGE - width));
  const bx = inside(bubble.left, bubble.width);
  /** A piece on the bubble's own side: a coach's message is right-aligned, so its pieces share the bubble's RIGHT edge. */
  const side = (width: number) => inside(mine ? bx + bubble.width - width : bx, width);
  const bubbleTop = top + barH;
  return {
    bar: bar === null ? null : { top, left: side(bar.width) },
    bubble: { top: bubbleTop, left: bx },
    bubbleHeight,
    card: { top: bubbleTop + bubbleHeight + HOLD_GAP, left: side(card.width) },
  };
}

/** How long a press is held before the menu opens (ms) — iOS's own long-press threshold is ~500. */
export const HOLD_MS = 450;
/** A press that travels further than this is a scroll or a text selection, never a hold (CSS px). */
export const HOLD_SLOP = 8;
